import { Injectable } from '@angular/core';
import { GlobalEmailTypes } from '../constants-types/Enums';
import { AssessmentAdministrator } from '../core-data-model/AssessmentAdministrator.model';
import { EmailDetails } from '../core-data-model/EmailDetails.model';
import { ScheduledAssessmentDetails } from '../core-data-model/ScheduledAssessmentDetails.model';
import { EmailDefaultService } from '../core-services/EmailDefault.dataservice';
import { SendAssessmentEmailDataService } from '../core-services/SendAssessmentEmail.dataservice';
import { DateFormatUtility } from '../core-utilities/DateFormat.utility';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { TranslationService } from '../translations';

/* while I am normally a little leery of factory patterns, I thought this was
a good way to have injectables be involved in object construction */
@Injectable({ providedIn: 'root' })
export class ScheduledAssessmentDetailsFactory {
    constructor(
        private initData: InitDataService,
        private dateUtilities: DateFormatUtility,
        private TR: TranslationService,
        private emailDefaultService: EmailDefaultService,
        private emailData: SendAssessmentEmailDataService
    ) {}

    makeScheduledAssessmentDetails(
        settings?: Partial<ScheduledAssessmentDetails>
    ): Promise<ScheduledAssessmentDetails> {
        return this.emailData.getSubjectsAndMessages().then(() => {
            // TODO - extract out user as well
            // TODO extract out setting folder
            const retval = new ScheduledAssessmentDetails();
            retval.assessments = [];
            retval.cognitiveEmail = new EmailDetails(
                GlobalEmailTypes.CognitiveAssessmentEmail
            );
            retval.behavioralEmail = new EmailDetails(
                GlobalEmailTypes.BehavioralAssessmentEmail
            );

            // You can modify these settings, but shouldn't modify your core user settings
            retval.behavioralEmail.administrator = new AssessmentAdministrator(
                this.initData.user
            );
            retval.behavioralEmail.assessmentExpirationDate =
                this.dateUtilities.getNowPlusDays(
                    this.initData.account.behavioralAssessmentExpirationInDays
                );
            retval.cognitiveEmail.administrator = new AssessmentAdministrator(
                this.initData.user
            );
            retval.cognitiveEmail.assessmentExpirationDate =
                this.dateUtilities.getNowPlusDays(
                    this.initData.account.cognitiveAssessmentExpirationInDays
                );
            retval.behavioralEmail.subject =
                this.emailDefaultService.setSubject(
                    GlobalEmailTypes.BehavioralAssessmentEmail,
                    this.TR
                );
            retval.behavioralEmail.message =
                this.emailDefaultService.setMessage(
                    GlobalEmailTypes.BehavioralAssessmentEmail,
                    this.TR
                );
            retval.cognitiveEmail.subject = this.emailDefaultService.setSubject(
                GlobalEmailTypes.CognitiveAssessmentEmail,
                this.TR
            );
            retval.cognitiveEmail.message = this.emailDefaultService.setMessage(
                GlobalEmailTypes.CognitiveAssessmentEmail,
                this.TR
            );
            Object.assign(retval, settings);
            return retval;
        });
    }
}
